import { LogOut } from 'lucide-react'

import { useLogoutMutation } from '@/api/auth/auth-queries'
import { BaronLockup } from '@/components/baron-mark'
import { MainNav } from '@/components/main-nav'
import { ThemeToggle } from '@/components/theme-toggle'
import { Button } from '@/components/ui/button'

/** Global application header: brand, primary navigation, and account actions. */
export function AppHeader() {
  const logout = useLogoutMutation()

  return (
    <header className="flex h-16 shrink-0 items-center justify-between gap-4 border-b bg-background px-5">
      <BaronLockup className="gap-2.5 [&>svg]:h-8 [&>svg]:w-9" />
      <div className="flex items-center gap-2">
        <MainNav />
        <span className="mx-1 hidden h-5 w-px bg-border md:block" />
        <ThemeToggle />
        <Button
          variant="ghost"
          size="icon"
          aria-label="Sign out"
          disabled={logout.isPending}
          onClick={() => logout.mutate()}
        >
          <LogOut className="size-4" />
        </Button>
      </div>
    </header>
  )
}
